var map = {
	"./arrow.svg": 7670,
	"./camera-active.svg": 8889,
	"./camera.svg": 8541,
	"./check.svg": 8964,
	"./close.svg": 4974,
	"./code-active.svg": 6309,
	"./code.svg": 5441,
	"./copy.svg": 118,
	"./customize-active.svg": 1899,
	"./customize.svg": 7990,
	"./dropbox-active.svg": 3068,
	"./dropbox.svg": 4285,
	"./facebook-active.svg": 9347,
	"./facebook.svg": 7202,
	"./gallery-active.svg": 960,
	"./gallery.svg": 3026,
	"./globe-active.svg": 8746,
	"./globe.svg": 6347,
	"./google-active.svg": 5677,
	"./google.svg": 7645,
	"./instagram-active.svg": 6973,
	"./instagram.svg": 9478,
	"./laptop-active.svg": 4538,
	"./laptop.svg": 981,
	"./launch.svg": 9672,
	"./logo-blue.svg": 6599,
	"./logo-small.svg": 3765,
	"./logo.svg": 5716,
	"./person.svg": 577,
	"./rectangle.svg": 7108,
	"./search.svg": 8762,
	"./upload.svg": 3989,
	"./upload1.svg": 1462,
	"./web-active.svg": 9490,
	"./web.svg": 5400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2334;